import { fcmUrl } from "api/baseUrl";
import axios from "axios";

export async function newMatchSend(matchMap) {
  try {
    const payload = {
      userType: "수리기사",
      alarmType: "매칭",
      ...matchMap,
    };

    await axios.post(`${fcmUrl}/post/newMatchSend`, payload, {
      headers: {
        "Content-Type": "application/json",
      },
      timeout: 5000,
    });
  } catch (error) {
    console.error("newCommunitySend 오류:", error);
  }
}

export async function doneMatchSend(matchMap, name) {
  try {
    const payload = {
      userType: "농가",
      alarmType: "매칭",
      expert: name,
      ...matchMap,
    };

    await axios.post(`${fcmUrl}/post/doneMatchSend`, payload, {
      headers: {
        "Content-Type": "application/json",
      },
      timeout: 5000,
    });
  } catch (error) {
    console.error("newCommunitySend 오류:", error);
  }
}
